class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("cart-item-update", this.onItemUpdate.bind(this));
  }

  connectedCallback() {
    // Close on background click
    this.addEventListener("click", (event) => {
      if (event.target === this) {
        this.close();
      }
    });

    // Delegate clicks for close buttons and empty cart button
    this.addEventListener("click", (event) => {
      if (
        event.target.closest(".close-cart-drawer") ||
        event.target.closest(".cart_is_empty__btn") ||
        event.target.closest(".continue-shopping")
      ) {
        event.preventDefault();
        this.close();
      }
    });
  }

  open() {
    if (window.closeMobileMenu) {
      window.closeMobileMenu();
    }
    this.classList.add("active");
    this.querySelector(".cart-drawer")?.classList.add("active");
    const openBtn = document.querySelector(".open-cart-drawer");
    if (openBtn) openBtn.setAttribute("aria-expanded", "true");
    document.body.classList.add("overflow-hidden");
    document.querySelector("main").classList.add("cart-open");
    if (window.innerWidth < 768) {
      if (window.lenis) window.lenis.stop();
    }
  }

  close() {
    this.classList.remove("active");
    this.querySelector(".cart-drawer")?.classList.remove("active");
    const closeBtn = this.querySelector(".close-cart-drawer");
    if (closeBtn) closeBtn.setAttribute("aria-expanded", "false");
    document.body.classList.remove("overflow-hidden");
    document.querySelector("main").classList.remove("cart-open");
    // if (window.lenis) window.lenis.start();
    if (window.innerWidth < 768) {
      if (window.lenis) window.lenis.start();
    }
  }

  async onItemUpdate(event) {
    const { id, quantity } = event.detail;

    const itemElement = this.querySelector(`cart-drawer-item[data-id="${id}"]`);
    if (itemElement) {
      const loader = itemElement.querySelector(".cart-item-loader");
      if (loader) loader.classList.add("state-loading");
      itemElement.classList.add("shimmer-effect", "is-loading");
    }

    const checkoutBtn = this.querySelector('button[name="checkout"]');
    if (checkoutBtn) {
      checkoutBtn.classList.add("checkout_btn_disabled");
      checkoutBtn.disabled = true;
    }

    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/change.js`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: id,
            quantity: quantity,
            sections: "cart-drawer,mejimeji-header",
          }),
        },
      );

      if (!response.ok) throw new Error("Failed to update cart");

      const data = await response.json();

      // Update drawer content
      if (data.sections && data.sections["cart-drawer"]) {
        this.renderContents(data.sections["cart-drawer"]);
      }

      // Update header cart count
      if (data.sections && data.sections["mejimeji-header"]) {
        this.updateCartCount(data.sections["mejimeji-header"]);
      }
    } catch (error) {
      console.error("Error updating cart:", error);

      if (checkoutBtn) {
        checkoutBtn.classList.remove("checkout_btn_disabled");
        checkoutBtn.disabled = false;
      }

      if (itemElement) {
        const loader = itemElement.querySelector(".cart-item-loader");
        if (loader) loader.classList.remove("state-loading");
        itemElement.classList.remove("shimmer-effect", "is-loading");
      }
    }
  }

  renderContents(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const newDrawerContent = doc.querySelector(".cart-drawer");
    const currentDrawerContent = this.querySelector(".cart-drawer");

    if (newDrawerContent && currentDrawerContent) {
      currentDrawerContent.innerHTML = newDrawerContent.innerHTML;
    }
  }

  updateCartCount(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const newCartButton = doc.querySelector(".open-cart-btn");
    const currentCartButton = document.querySelector(".open-cart-btn");

    if (newCartButton && currentCartButton) {
      currentCartButton.innerHTML = newCartButton.innerHTML;
    }
  }
}

if (!customElements.get("cart-drawer")) {
  customElements.define("cart-drawer", CartDrawer);
}

// Global helper functions to maintain compatibility with other scripts
window.openCart = () => {
  const drawer = document.querySelector("cart-drawer");
  if (drawer) drawer.open();
};

window.closeCart = () => {
  const drawer = document.querySelector("cart-drawer");
  if (drawer) drawer.close();
};

window.getCart = async () => {
  const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
    method: "GET",
  });
  const data = await response.json();
  return data;
};

window.updateCartDrawer = async () => {
  const drawer = document.querySelector("cart-drawer");
  if (drawer) {
    const res = await fetch(
      window.Shopify.routes.root + "?section_id=cart-drawer",
    );
    const text = await res.text();
    drawer.renderContents(text);
  }
};

window.updateCartCount = (htmlString) => {
  const drawer = document.querySelector("cart-drawer");
  if (drawer) {
    drawer.updateCartCount(htmlString);
  }
};
